import React, { useState, useEffect } from "react";
import "./index.scss";

const LoadingCard = (props: any) => {
  useEffect(() => {}, []);

  return (
    <div
      style={{
        backgroundColor: "#fff",
        textAlign: "center",
        paddingTop: "2rem",
        paddingBottom: "4rem",
        borderRadius: "5px",
        boxShadow: "grey 0px 3px 7px -5px",
      }}
    >
      กำลังโหลดข้อมูล/Loading...
    </div>
  );
};
export default LoadingCard;
